const visitUrl = (newUrl, event) => {
  if (!newUrl) return

  event.preventDefault()

  if (event.ctrlKey || event.metaKey) {
    window.open(newUrl, '_blank')
  } else {
    Turbo.visit(newUrl)
  }
}

const visitElementLink = ($element, event) => {
  visitUrl($element.attr('href'), event)
}

/**
 * Legacy method to add clickable rows, should be using stimulus instead
 */
export const withClickableRows = (clickableElement) => {
  $(clickableElement).on('click', 'tbody td', function (event) {
    // Ignore no-results table rows
    if ($(event.currentTarget).hasClass('dataTables_empty')) return

    let newUrl

    const clickedTargetLink = $(event.currentTarget).find('a')
    if (clickedTargetLink.length > 0) {
      // Visit the link in the the target cell
      newUrl = $(clickedTargetLink).attr('href')
    } else {
      // Visit the link in the first cell of the table
      const defaultRowLink = $(
        event.currentTarget.parentElement.firstElementChild
      ).find('a')

      if (defaultRowLink.length > 0) {
        newUrl = $(defaultRowLink).attr('href')
      }
    }

    // Visit the URL if we found one
    if (newUrl) visitUrl(newUrl, event)
  })
}

/**
 * Handles the stimulus action for clicking on a datatable row.
 */
export const handleClickableRowClick = (event) => {
  if (event.target.tagName === 'A') return // let links handle themselves

  const $linkElement = $(event.target).closest('a')
  if ($linkElement.length > 0) {
    return // let the closest link handle itself
  }

  // Find the current cell of the click
  const $cellElement = $(event.target).closest('th,td')

  // Attempt to visit the link in the current cell
  const $cellLinks = $cellElement.find('a:first')
  if ($cellLinks.length > 0) {
    visitElementLink($cellLinks, event)
    return
  }

  // Attempt to visit the first link in the current row
  const $defaultLink = $cellElement.closest('tr').find('th:first a, td:first a')
  if ($defaultLink.length > 0) {
    visitElementLink($defaultLink, event)
  }
}
